import { render, staticRenderFns } from "./CustomerHierarchyItem.vue?vue&type=template&id=56ad6364&"
import script from "./CustomerHierarchyItem.vue?vue&type=script&lang=ts&"
export * from "./CustomerHierarchyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports